import { React, useContext, useEffect, useState } from "react";
import { AppContext } from "../contexts/AppContext";
import lineImg from "../assets/images/line.png";
import blockImg from "../assets/images/block.png";
import conesImg from "../assets/images/cones.png";
import contourImg from "../assets/images/contour.png";
import blockDiagram from "../assets/images/block_diagram.png";
import lineDiagram from "../assets/images/line_diagram.png";
import conesDiagram from "../assets/images/cones_diagram.png";
import contourDiagram from "../assets/images/contour_diagram.png";

import {
  calculateSupportVolume,
  calculateThermalStress,
  calculateTemperature,
  calculateDisplacement,
} from "../js/functions";

const TableComponent = () => {
  const supportTypesArray = [
    {
      name: "BLOCK",
      isSelected: true,
      toothHeight: { min: 1.0, max: 4.0, value: 2.5, step: 0.1 },
      toothTop: { min: 0.1, max: 0.5, value: 0.3, step: 0.01 },
      xyHatching: { min: 0.5, max: 2.0, value: 1.25, step: 0.1 },
      supportVolume: { min: 1438.4, max: 4643.3, value: 2530.35, step: 1.0 },
      thermalStress: {
        min: 3340000000,
        max: 5540000000,
        value: 48000000,
        step: 1000,
      },
      temperature: { min: 792, max: 1030, value: 877, step: 1 },
      displacement: { min: 0.411, max: 0.441, value: 0.4295, step: 0.0001 },
      img: blockImg,
      diagramImg: blockDiagram,
    },
    {
      name: "LINE",
      isSelected: false,
      toothHeight: { min: 1.0, max: 4.0, value: 2.5, step: 0.1 },
      toothTop: { min: 0.1, max: 0.5, value: 0.3, step: 0.01 },
      xyHatching: { min: 0.5, max: 2.0, value: 1.25, step: 0.1 },
      supportVolume: { min: 791.1, max: 2361.0, value: 1576, step: 1.0 },
      thermalStress: {
        min: 4730000000,
        max: 8820000000,
        value: 67750000000,
        step: 1000,
      },
      temperature: { min: 762, max: 959, value: 860.5, step: 1 },
      displacement: { min: 0.392, max: 0.454, value: 0.423, step: 0.0001 },
      img: lineImg,
      diagramImg: lineDiagram,
    },
    {
      name: "CONTOUR",
      isSelected: false,
      toothHeight: { min: 1.0, max: 4.0, value: 2.25, step: 0.1 },
      toothTop: { min: 0.1, max: 0.5, value: 0.3, step: 0.01 },
      xyHatching: { min: 0.5, max: 2.0, value: 1.25, step: 0.1 },
      supportVolume: { min: 792, max: 2358, value: 1575, step: 1.0 },
      thermalStress: {
        min: 3820000000,
        max: 5290000000,
        value: 4550000000,
        step: 1000,
      },
      temperature: { min: 775, max: 1030, value: 902.5, step: 1 },
      displacement: { min: 0.416, max: 0.465, value: 0.4405, step: 0.0001 },
      img: contourImg,
      diagramImg: contourDiagram,
    },
    {
      name: "CONES",
      isSelected: false,
      toothHeight: { min: 1.0, max: 2.0, value: 1.25, step: 0.1 },
      toothTop: { min: 0.2, max: 0.4, value: 0.3, step: 0.01 },
      xyHatching: { min: 0.5, max: 2.0, value: 1.25, step: 0.1 },
      supportVolume: { min: 417.4, max: 2104.1, value: 1260.75, step: 1.0 },
      thermalStress: {
        min: 5950000000,
        max: 62600000000,
        value: 61050000000,
        step: 1000,
      },
      temperature: { min: 724, max: 834, value: 779, step: 1 },
      displacement: { min: 0.45, max: 0.447, value: 0.4635, step: 0.0001 },
      img: conesImg,
      diagramImg: conesDiagram,
    },
  ];
  const parametersArray = [
    {
      label: {
        BLOCK: "Tooth Height",
        LINE: "Tooth Height",
        CONTOUR: "Tooth Height",
        CONES: "Lower Diameter",
      },
      id: "toothHeight",
    },
    {
      label: {
        BLOCK: "Tooth Top Length",
        LINE: "Tooth Top Length",
        CONTOUR: "Tooth Top Length",
        CONES: "Upper Diameter",
      },
      id: "toothTop",
    },
    {
      label: {
        BLOCK: "X,Y Hatching",
        LINE: "Cross Line Interval",
        CONTOUR: "Contour Offset",
        CONES: "Cone Spacing",
      },
      id: "xyHatching",
    },
  ];
  const variablesArray = [
    { label: "Support Volume", id: "supportVolume" },
    { label: "Thermal Stress", id: "thermalStress" },
    { label: "Supports' Heat Transmission", id: "temperature" },
    { label: "Overhang Displacement", id: "displacement" },
  ];
  const { table, setTable } = useContext(AppContext);
  const [selectedSupportType, setSelectedSupportType] = useState(
    supportTypesArray[0]
  );
  const [supportTypes, setSupportTypes] = useState(supportTypesArray);

  //update array of support types whenever the information of the selected support type is modified
  useEffect(() => {
    setSupportTypes(
      supportTypes.map((supportType) => {
        if (supportType.name === selectedSupportType.name) {
          return selectedSupportType;
        } else return { ...supportType, isSelected: false };
      })
    );
    // eslint-disable-next-line
  }, [selectedSupportType]);

  let supportTypesList =
    supportTypes !== undefined &&
    supportTypes.map((supportType) => {
      return (
        <li id={supportType.name}>
          <span
            className={supportType.isSelected ? "highlight" : ""}
            onClick={(e) => {
              supportTypes.map((supportType) => {
                if (supportType.name === e.target.innerText) {
                  setSelectedSupportType({ ...supportType, isSelected: true });
                }
                return supportType;
              });
            }}
          >
            {supportType.name}
          </span>
        </li>
      );
    });

  let parametersList = parametersArray.map((parameter) => {
    return (
      <>
        <div className="table-info-row">
          <label>{parameter.label[selectedSupportType.name]}</label>
          <slidermin>{selectedSupportType[parameter.id].min}mm</slidermin>
          <input
            id="parameters-slider"
            type="range"
            min={selectedSupportType[parameter.id].min}
            max={selectedSupportType[parameter.id].max}
            step={selectedSupportType[parameter.id].step}
            value={selectedSupportType[parameter.id].value}
            onChange={(e) => {
              let values = {};
              switch (parameter.id) {
                case "toothHeight":
                  values = {
                    name: selectedSupportType.name,
                    toothHeight: {
                      ...selectedSupportType.toothHeight,
                      value: parseFloat(e.target.value),
                    }.value,
                    toothTop: selectedSupportType.toothTop.value,
                    xyHatching: selectedSupportType.xyHatching.value,
                  };
                  break;
                case "toothTop":
                  values = {
                    name: selectedSupportType.name,
                    toothHeight: selectedSupportType.toothHeight.value,
                    toothTop: {
                      ...selectedSupportType.toothTop,
                      value: parseFloat(e.target.value),
                    }.value,
                    xyHatching: selectedSupportType.xyHatching.value,
                  };
                  break;
                case "xyHatching":
                  values = {
                    name: selectedSupportType.name,
                    toothHeight: selectedSupportType.toothHeight.value,
                    toothTop: selectedSupportType.toothTop.value,
                    xyHatching: {
                      ...selectedSupportType.xyHatching,
                      value: parseFloat(e.target.value),
                    }.value,
                  };
                  break;
                default:
                  return;
              }
              setSelectedSupportType({
                ...selectedSupportType,
                [parameter.id]: {
                  ...selectedSupportType[parameter.id],
                  value: parseFloat(e.target.value),
                },
                supportVolume: {
                  ...selectedSupportType.supportVolume,
                  value: calculateSupportVolume(values),
                },
                thermalStress: {
                  ...selectedSupportType.thermalStress,
                  value: calculateThermalStress(values),
                },
                temperature: {
                  ...selectedSupportType.temperature,
                  value: calculateTemperature(values),
                },
                displacement: {
                  ...selectedSupportType.displacement,
                  value: calculateDisplacement(values),
                },
              });
            }}
            className="slider"
          />
          <slidermax>{selectedSupportType[parameter.id].max}mm</slidermax>
          <label class="range-label">
            {selectedSupportType[parameter.id].value.toFixed(2)}mm
          </label>
        </div>
      </>
    );
  });

  let variablesList = variablesArray.map((variable) => {
    let style = { transform: "scaleX(1)" };
    if (variable.id !== "temperature") {
      style = { transform: "scaleX(-1)" };
    }
    return (
      <div className="table-info-row">
        <label>{variable.label}</label>

        <input
          style={style}
          id="variables-slider"
          min={selectedSupportType[variable.id].min}
          max={selectedSupportType[variable.id].max}
          value={selectedSupportType[variable.id].value}
          step={selectedSupportType[variable.id].step}
          type="range"
          className="slider"
          disabled
        />
        <sliderlabel>Opt.</sliderlabel>
      </div>
    );
  });

  return (
    <>
      {table !== undefined && (
        <div className="table-panel">
          <div className="table-select">
            <ul>
              {supportTypesList}
              <img
                src={selectedSupportType.img}
                alt="support type"
                id="support-type-img"
              ></img>
            </ul>
          </div>
          <div className="table-info">
            <label className="title">SUPPORT OPTIMIZATION ENGINE</label>
            <span>{parametersList}</span>

            <span>{variablesList}</span>
            <label class="img-label">
              Optimal parameters for {selectedSupportType.name.toLowerCase()}
              -type supports{" "}
            </label>
            <img
              src={selectedSupportType.diagramImg}
              alt="support type diagram"
              id="support-type-diagram"
            ></img>
          </div>
          <div
            className="close-button"
            onClick={(e) => {
              setTable(undefined);
            }}
          ></div>
        </div>
      )}
    </>
  );
};
export default TableComponent;
